<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb and Header Buttons Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Sales</span>
                    <a>Campaign</a>
                </div>
                <div class="d-flex flex-wrap align-items-center margin865">
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" disabled><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <button class="btn btn-new-danger btn-wide px-6 mr-4" v-if="userPermissions.campaigns.permitted_actions.delete" :style="selectedCampaigns.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selectedCampaigns.length ? $modal.show('deleteCampaign') : ''" :disabled="disableDelete">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6 margin665" v-if="userPermissions.campaigns.permitted_actions.create" @click="$router.push('/campaign/email/createCampaignEmail/')">+ Create Campaign</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_campaign_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" placeholder="Search by Campaign Name" v-model="search_campaign_key" v-debounce:500ms="searchCampaign" debounce-events="input" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px">
                    </div>
                </div>
            </div>
            <!-- Table View Section -->
            <div class="table-block overflow-x-auto pt-10" style="background-color:#fff;border-top-right-radius:5px">
                <table class="team-list-table w-100">
                    <thead style="width: 100% !important">
                        <tr>
                            <th v-if="userPermissions.campaigns.permitted_actions.delete && loggedInUser.user_role != 'team_lead'" style="width: 10px !important;padding: 13px 14px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectALL" v-model="select_all_campaigns"/>
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th v-if="userPermissions.campaigns.permitted_actions.view" style="width: 10px !important;padding: 13px 14px !important"></th>
                            <th v-if="userPermissions.campaigns.permitted_actions.edit" style="width: 10px !important;padding: 13px 14px !important"></th>
                            <th style="width: 18% !important">CAMPAIGN NAME</th>
                            <!-- <th style="width: 18% !important">INDUSTRY TYPE</th> -->
                            <th style="width: 18% !important">START DATE</th>
                            <th style="width: 18% !important">END DATE</th>
                            <th style="width: 18% !important">TEMPLATE</th>
                            <th style="width: 18% !important">STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallInProgress">
                            <td colspan="9">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && campaigns.length == 0" class="text-center font-weight-bold" style="height: 400px !important;">
                            <td colspan="15">
                                <img src="/static/images/territory-sales.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center">No Campaign added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(campaign, index) in campaigns" :key="index">
                            <td v-if="userPermissions.campaigns.permitted_actions.delete" style="width: 10px !important;padding: 13px 14px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectOne($event, campaign, index)" v-model="campaign.checked"/>
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td v-if="userPermissions.campaigns.permitted_actions.view" style="width: 10px !important;padding: 13px 14px !important">
                                <div class="pointer">
                                    <el-tooltip class="item" effect="dark" content="View" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="viewCampaign(campaign._id)">
                                            <i class="icon icon-eye fs-20 text-dark-blue w-1re pointer"></i>
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td v-if="userPermissions.campaigns.permitted_actions.edit" style="width: 10px !important;padding: 13px 14px !important">
                                <div class="pointer" v-if="campaign.status != 'approved'">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="editCampaign(campaign._id)">
                                            <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td class="text-capitalize new-blue-text pointer text-truncate cell-width" v-if="campaign.status == 'approved'" @click="campaignAnalytics(campaign._id, campaign.start_date, campaign.category_id)" :title="campaign.name">
                                {{ campaign.name || "-" }}
                            </td>
                            <td class="text-truncate cell-width text-capitalize new-blue-text" :title="campaign.name" v-else>
                                {{ campaign.name || "-" }}
                            </td>
                            <!-- <td class="text-truncate cell-width pointer text-ellipsis" :title="campaign.industry_type">{{ campaign.industry_type || "-" }}</td> -->
                            <td>{{ campaign.start_date || "-" }}</td>
                            <td>{{ campaign.end_date || "-" }}</td>
                            <td class="text-capitalize">{{ campaign.template_type.replace("_"," ") || "-" }}</td>
                            <td>
                                <button style="text-transform: capitalize; width: 130px !important;" class="btn btn-smm text-white btn-default btn-width"
                                    :class="{
                                    'btn-pending':campaign.status == 'pending',
                                    'btn-approved':campaign.status == 'approved',
                                    'btn-rejected':campaign.status == 'rejected'}">
                                        {{ campaign.status[0].toUpperCase() + campaign.status.substring(1) }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="campaigns.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <div v-if="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data @hideFilters="hideFilters"  :showfilterData="showfilterData" @appliedFilter="appliedFilter"></filter-data>
            </div>
        </div>
        <delete-campaign modal_name="deleteCampaign" @deleteCampaigns="deleteCampaigns"></delete-campaign>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import campaignList from "../../mixins/campaign.js"
import DeleteCampaign from "../../alertModals/DeleteCampaign";
const FilterData = () => import('./FilterData')
import { SweetModal } from 'sweet-modal-vue';
export default {
    data(){
        return{
            select_all_campaigns: false,
            disableDelete: true,
            success_msg:"",
            warning_msg:"",
            ajaxCallInProgress: false,
            campaigns: [],
            selectedCampaigns: [],
            display_filters: false,
            hide_filters: false,
            showfilterData: {
                campaign_name: [],
                industry_type: [],
                start_date: "",
                end_date: "",
                template: [],
                status: []
            },
            filterData: {
                campaign_name: [],
                industry_type: [],
                start_date: "",
                end_date: "",
                template: [],
                status: []
            },
            temp_total: 0,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            search_campaign_key: ''
        }
    },
    mixins: [campaignList],
    components: {
        DeleteCampaign,
        FilterData,
        HalfCircleSpinner,
        SweetModal
    },
    methods:{
        clearSearch(){
            this.search_campaign_key = ""
            this.$refs.searchInput.focus();
            this.getCampaigns();
        },
        //API call to load campaigns data
        async getCampaigns() {
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: "",
                    type: "email",
                    "filter_json": {
                        "campaign_ids": this.filterData.campaign_name,
                        "end_date": this.filterData.end_date,
                        "industry_type": this.filterData.industry_type,
                        "start_date": this.filterData.start_date,
                        "status": this.filterData.status,
                        "template_type": this.filterData.template
                    },
                };
                let response = await this.getCampaignList(params)
                this.total = response.count
                this.campaigns = response.response
                this.campaigns.forEach((el, el_index) => {
                    this.campaigns[el_index].checked = false;
                    if(this.selectedCampaigns.length){
                        this.selectedCampaigns.forEach((el_selected, el_selected_index) => {
                            if(el_selected === el._id){
                                this.campaigns[el_index].checked = true;
                            }
                        })
                    }
                })
                if(this.campaigns.every(x => x.checked == true)){
                    this.select_all_campaigns = true;
                } else {
                    this.select_all_campaigns = false;
                }
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        //API call to seach campaigns
        async searchCampaign(){
            this.ajaxCallInProgress = true
            this.selectedCampaigns = [];
            this.select_all_campaigns = false;
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_campaign_key,
                    type: "email",
                    "filter_json": {
                        "campaign_ids": this.filterData.campaign_name,
                        "end_date": this.filterData.end_date,
                        "industry_type": this.filterData.industry_type,
                        "start_date": this.filterData.start_date,
                        "status": this.filterData.status,
                        "template_type": this.filterData.template
                    },
                };
                let response = await this.getCampaignList(params)
                this.campaigns = response.response
                this.total = response.count
                if(this.campaigns.length != 0){
                    this.campaigns.forEach((el, el_index) => {
                        this.campaigns[el_index].checked = false;
                        if(this.selectedCampaigns.length){
                            this.selectedCampaigns.forEach((el_selected, el_selected_index) => {
                                if(el_selected === el._id){
                                    this.campaigns[el_index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.campaigns.every(x => x.checked == true)){
                        this.select_all_campaigns = true;
                    } else {
                        this.select_all_campaigns = false;
                    }
                }
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        //Pagination methods
        firstPage(){
            //this.selectedCampaigns = []
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getCampaigns()
        },
        nextPage() {
            //this.selectedCampaigns = []
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getCampaigns()
        },
        previousPage() {
            //this.selectedCampaigns = []
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getCampaigns()
        },
        lastPage() {
            //this.selectedCampaigns = []
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getCampaigns()
        },
        viewCampaign(id) {
            this.$router.push('/campaign/email/approveEmail/'+ id);
        },
        editCampaign(id) {
            this.$router.push('/campaign/email/editCampaignEmail/'+ id);
        },
        //Select all checkbox function
        selectALL(event){
            if(event.target.checked === true){
                this.campaigns.forEach((campaign, index) => {
                    if(this.campaigns[index].checked == false){
                        this.campaigns[index].checked = true;
                        this.selectedCampaigns.push(campaign._id)
                    }
                })
                this.disableDelete = false;
            } else {
                this.campaigns.forEach((campaign, index) => {
                    this.campaigns[index].checked = false;
                })
                this.campaigns.forEach((camp_list, camp_list_index) => {
                    this.selectedCampaigns.forEach((selected_camp, selected_camp_index) => {
                        if(camp_list._id == selected_camp){
                            this.selectedCampaigns.splice(selected_camp_index, 1)
                        }
                    })
                })
                this.disableDelete = true;
            }
        },
        //Select single campaign checkbox function
        selectOne(event, campaign, camp_index) {
            if(event.target.checked){
                this.selectedCampaigns.push(campaign._id)
                this.disableDelete = false;
            } else {
                this.selectedCampaigns.forEach((selected_camp, selected_camp_index) => {
                    if(selected_camp === campaign._id){
                        this.selectedCampaigns.splice(selected_camp_index, 1)
                    }
                })
                if(this.selectedCampaigns.length == 0){
                    this.disableDelete = true;
                }
            }
            if(this.campaigns.every(x => x.checked == true)){
                this.select_all_campaigns = true;
            } else {
                this.select_all_campaigns = false;
            }
        },
        //API call to delete campaign
        async deleteCampaigns(){
            try{
                let params = {
                    ids: this.selectedCampaigns
                }
                let response = await this.deleteCampaignsByID(params)
                this.$modal.hide("deleteCampaign");
                //this.getCampaigns();
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    //this.$modal.hide("deleteCampaign");
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.selectedCampaigns = [];
                        this.getCampaigns();
                        this.$refs.success_modal.close();
                    }, 2000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 2000);
                }
            }
            catch(reason){

            }
        },
        //Redirects to campaign statistics page
        async campaignAnalytics(id, date, category_id){
            this.$router.push(`/campaign/email/campaignEmailDetails?category_id=${category_id}&start_date=${date}&campaign_id=${id}`)
        },
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        appliedFilter(data){
            this.selectedCampaigns = [];
            this.filterData = {
                campaign_name: data.value.created_campaign_name,
                industry_type: data.value.created_industry_type,
                start_date: data.value.created_start_date,
                end_date: data.value.created_end_date,
                template: data.value.created_template,
                status: data.value.created_status
            }
            this.showfilterData = {
                campaign_name: data.value1.created_campaign_name,
                industry_type: data.value1.created_industry_type,
                start_date: data.value1.created_start_date,
                end_date: data.value1.created_end_date,
                template: data.value1.created_template,
                status: data.value1.created_status
            }
            this.getCampaigns();
        }
    },
    mounted(){
        this.getCampaigns();
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
}
</script>
<style scoped>
    .scm-filters{
        height: fit-content !important;
        padding-bottom: 20px !important;
        overflow: auto !important;
    }
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .btn-pending{
        background: #E4A045 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-approved{
        background: #078A63 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-rejected{
        background: #E64646 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .cell-width{
        max-width: 300px;
    }
    .overflow-x-auto{
        overflow-x: auto !important
    }
    .text-dark-blue {
          color: #00448b;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 865px) {
        .margin865{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 665px) {
        .margin665{
            margin-top: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Campaign/Email/CampaignEmailListView.vue